import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { connect } from 'react-redux';
import { getList, getRemoteList, setPaginaAtual, addNewError, syncNotificationsFromLocalStorage } from './erroActions';
import { parseISO, format, isValid } from 'date-fns';
import { toastr } from 'react-redux-toastr';
import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import socketService from '../services/socketService';
import configLocal from '../configuracao/configLocal';

moment.locale('pt-br');

class ControladorErroList extends Component {
  constructor(props) {
    super(props);

    this.carregarErro = this.carregarErro.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);

    this.state = {
      show: false,
    };

    // Watchers para mudanças de filtro (grupo/numCont)
    this.filterWatcherId = 0;
    this.currentGrupo = null;
    this.currentNumCont = null;
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  componentWillUnmount() {
    // TEMPORARIAMENTE DESABILITADO
    // // Remover listener do WebSocket
    // socketService.removeEventListener('lista_erros_atualizada', this.handleErrorListUpdate);
    // Remover watcher de filtro
    if (this.filterWatcherId) clearInterval(this.filterWatcherId);
  }

  componentDidMount() {
    // Carregar notificações do localStorage ao iniciar
    this.props.syncNotificationsFromLocalStorage();

    // TEMPORARIAMENTE DESABILITADO - WebSocket será usado apenas no sistema de notificações
    // // Adicionar listener para a lista de erros atualizada via WebSocket
    // this.handleErrorListUpdate = () => {
    //   this.props.getList();
    // };
    // socketService.addEventListener('lista_erros_atualizada', this.handleErrorListUpdate);

    // // Verificar se a conexão WebSocket está ativa
    // if (!socketService.socket || !socketService.connected) {
    //   socketService.connect();
    // }

    // Iniciar watcher para alterações de filtro (grupo/numCont)
    try {
      this.currentGrupo = configLocal.getConfig('grupo');
      this.currentNumCont = configLocal.getConfig('numCont');
      this.filterWatcherId = setInterval(() => {
        const novoGrupo = configLocal.getConfig('grupo');
        const novoNumCont = configLocal.getConfig('numCont');
        if (novoGrupo !== this.currentGrupo || novoNumCont !== this.currentNumCont) {
          this.currentGrupo = novoGrupo;
          this.currentNumCont = novoNumCont;
          // Resetar paginação e recarregar lista
          this.props.setPaginaAtual(0);
          this.props.getList();
        }
      }, 1000);
    } catch (_) {}
  }

  componentWillMount() {
    this.props.getList();
  }

  handleClose() {
    this.setState({ show: false });
  }

  timeFormat(time) {
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);
    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;
    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  }

  handleChangeTime(value, onChange) {
    const time = this.timeFormat(value);
    onChange(time);
  }

  carregarErro() {
    this.setState({ show: true });
    this.props
      .getRemoteList()
      .then(result => {
        this.props.getList();
        this.setState({ show: false });
        toastr.success('Sucesso', 'Operação Realizada com sucesso.');
      })
      .catch(e => {
        this.setState({ show: false });
        toastr.error('Erro', 'Sem conexão');
      });
  }

  render() {
    moment.locale('pt-br');

    const contErro = this.props.list || [];
    const paginaAtual = this.props.paginaAtual;

    const columns = [
      {
        Header: 'Data',
        accessor: 'data_erro',
        minWidth: 100,
        maxWidth: 140,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
        Filter: ({ filter, onChange }) => (
          <input
            type="date"
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : ''}
            className="form-control"
          />
        ),
        filterMethod: (filter, row) => {
          if (isValid(parseISO(row[filter.id]))) {
            const dataValue = format(parseISO(row[filter.id]), 'yyyy-MM-dd');
            return dataValue === filter.value;
          }
        },
      },
      {
        Header: 'Hora',
        accessor: 'hora_erro',
        minWidth: 80,
        maxWidth: 120,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => this.handleChangeTime(event.target.value, onChange)}
            value={filter ? filter.value : ''}
            type="text"
            maxLength={8}
            placeholder="hh:mm:ss"
            className="form-control"
            style={{ width: '100%', textAlign: 'center' }}
          />
        ),
      },
      {
        Header: 'Mensagem',
        accessor: 'mensagem',
        minWidth: 300,
        className: 'column_grid',
        style: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        },
        filterable: true,
        resizable: true,
      },
    ];

    const toolbarButton = (
      <button
        type="button"
        className="btn btn-success"
        style={{
          height: '36px',
          borderRadius: '10px',
          fontSize: '13px',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '0 14px',
          border: 'none',
          boxShadow: '0 2px 8px rgba(40,167,69,0.15)',
        }}
        onClick={this.carregarErro}
        disabled={this.state.show}
        title="Busca erros do controlador para gravar no banco e exibe"
      >
        <i className={`fa ${this.state.show ? 'fa-spinner fa-spin' : 'fa-download'}`} />
        <span>Carregar Erros do Controlador</span>
      </button>
    );

    return (
      <div className="table-container" style={{ marginTop: '20px', width: '100%' }}>
        {/* Overlay de loading */}
        {this.state.show && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.3)',
              zIndex: 2000,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              paddingTop: '15vh',
              animation: 'fadeIn 0.3s ease-out',
            }}
          >
            <div
              style={{
                background: 'rgb(255, 255, 255)',
                border: '1px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(8px)',
                borderRadius: '16px',
                padding: '2rem 3.5rem',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                animation: 'popUp 0.3s ease-out',
              }}
            >
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  border: '6px solid rgba(0, 0, 0, 0.3)',
                  borderTop: '6px solid #4286f4',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />
              <div
                style={{
                  marginTop: '1rem',
                  color: 'rgb(0 0 0)',
                  fontSize: '1.5rem',
                  textAlign: 'center',
                  maxWidth: '225px',
                }}
              >
                Buscando os erros do controlador...
                <br />
                Aguarde alguns instantes
              </div>
            </div>
            <style>{`
              @keyframes spin { to { transform: rotate(360deg); } }
              @keyframes popUp { 0% { transform: translateY(-20px) scale(0.95); opacity: 0; } 100% { transform: translateY(0) scale(1); opacity: 1; } }
              @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
            `}</style>
          </div>
        )}

        <style>{`
          .controlador-erro-premium-table .ReactTable .rt-th.column_center,
          .controlador-erro-premium-table .ReactTable .rt-td.column_center {
            justify-content: center;
            text-align: center;
          }

          .controlador-erro-premium-table .ReactTable .rt-th .rt-resizable-header-content,
          .controlador-erro-premium-table .ReactTable .rt-th .rt-th-content {
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .controlador-erro-premium-table .ReactTable .rt-td,
          .controlador-erro-premium-table .ReactTable .rt-th {
            font-size: 12px;
          }
        `}</style>

        <div className="controlador-erro-premium-table">
          <PremiumTableShell
            summary={`${contErro.length} erro(s) exibido(s)`}
            toolbarRight={toolbarButton}
            tableMinWidth={0}
          >
            <ReactTableGT2A
              data={contErro}
              columns={columns}
              className="-striped -highlight"
              defaultPageSize={15}
              showPagination
              filterable={true}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
              style={{
                fontSize: '13px',
                width: '100%',
              }}
            />
          </PremiumTableShell>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.controladorErroCad.list,
  paginaAtual: state.controladorErroCad.paginaAtual,
});
const mapDispatchToProps = dispatch => ({
  dispatch,
  ...bindActionCreators(
    {
      getList,
      getRemoteList,
      setPaginaAtual,
      addNewError,
      syncNotificationsFromLocalStorage,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControladorErroList);
